module.exports = __webpack_public_path__ + "static/media/cover.b930030e.png";